import css from './Experience.module.scss'
import SubTitle from "../SubTitle";
import Animate from "../Animate";

const ExperienceCard = ({xp}) => {
  return (
      <>
        <div className={`${css.experienceCard} mb-12`}>
          <div className='mb-3'>
            {xp.link ? <a href={xp.link} target="_blank" rel="noreferrer">
                <SubTitle title={xp.name}/>
              </a> :
                <SubTitle title={xp.name}/>
            }
          </div>
          <Animate direction='up' duration={0.5} delay={0.2} distance={60} scrollTriggerStart='20% bottom'>

            {xp.link ? <a href={xp.link} target="_blank" rel="noreferrer">
              <img src={xp.logo} alt="" className={`rounded bg-white p-1 mb-4`} style={{height: '50px'}}/>
            </a> :
              <img src={xp.logo} alt="" className={`rounded bg-white p-1 mb-4`} style={{height: '50px'}}/>
            }
          </Animate>
          <Animate direction='up' duration={0.5} delay={0.2} distance={100} scrollTriggerStart='20% bottom'>
            <div className='mb-2'>
              <strong>
                {xp.startDate} - {xp.endDate},
                {xp.xp ? <span className='m-2 text-rose-500'>{xp.xp}</span> : ''}
              </strong>
            </div>
            <p><strong>Role: <span className='ml-2 text-amber-500'>{xp.role}</span></strong></p>
            <div className='text-base'>
              {xp.description}
              {xp.coreTechnologies && xp.coreTechnologies.map((cT, k) => (
                  <span key={k}>
                              <strong className={'ml-2 text-amber-500'}>{cT}</strong>
                              <span>{xp.coreTechnologies.length - 1 > k ? ', ' : ''}</span>
                            </span>
              ))}.
            </div>
          </Animate>
        </div>
      </>
  );
}

export default ExperienceCard;
